import { render, staticRenderFns } from "./ArticleCateTree.vue?vue&type=template&id=54c817e4&scoped=true"
import script from "./ArticleCateTree.vue?vue&type=script&lang=js"
export * from "./ArticleCateTree.vue?vue&type=script&lang=js"
import style0 from "./ArticleCateTree.vue?vue&type=style&index=0&id=54c817e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c817e4",
  null
  
)

export default component.exports